<div class="logout-button">
    <div class="logout-button__user ellipsis">{{userName}}</div>
    <ct-user-avatar></ct-user-avatar>
</div>
